import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import CircularProgress from '@mui/material/CircularProgress';

const useStyles = makeStyles(theme => ({
  progress: {
    margin: theme.spacing(2),
  },
}));

export default function Spinner() {
  const classes = useStyles();

  return (
    <div className="text-center" style={{
        top:"50%",
        left:"50%",
        position:"absolute",
        }}>
      {/* <CircularProgress className={classes.progress} /> */}
      
      <CircularProgress className={classes.progress} color="secondary" />
    </div>
  );
}